/* istanbul ignore file */
import { getSynergyCaseStatus } from 'api/case/caseSynergy';
import getServiceStatusApi from 'api/serviceStatus';
import { push } from 'connected-react-router';
import { call, put, select } from 'redux-saga/effects';
import actions from 'redux/actions/caseStatus';
import { caseReferenceSelector } from 'redux/selectors/caseStatus';
import loaderActions from 'redux/actions/applicationSpinnerActions';
import {
  partnerSelector,
  selectMoveVersion,
  selectTenantId,
} from 'redux/selectors/config';
import { routes } from 'Routes/routesConfig';
import { getSynergySessionToken } from 'utils/sagas-utils';

export function* getCaseStatusSaga({
  payload: { caseReference, navigateToCaseStatus, showLoader = false },
}) {
  try {
    if (showLoader) {
      yield put(loaderActions.startLoad({}));
    }
    const moveVersion = yield select(selectMoveVersion);
    const sessionToken = yield getSynergySessionToken();
    const tenantId = yield select(selectTenantId);
    const caseReferenceFromStore = yield select(caseReferenceSelector);
    const { result, status } = yield call(getSynergyCaseStatus, {
      caseId: caseReference || caseReferenceFromStore,
      token: sessionToken,
      moveVersion,
      tenantId,
    });

    if (status === 200 && result?.length > 0) {
      yield put(actions.getCaseStatusSuccess(result));
      if (navigateToCaseStatus) {
        yield put(push(routes.SYNERGY_FOLLOW_CONFIRMATION));
      }
    } else {
      yield put(actions.getCaseStatusError('Case not found'));
    }
  } catch (error) {
    yield put(actions.getCaseStatusError(error?.message || error));
  } finally {
    if (showLoader) {
      yield put(loaderActions.stopLoad({}));
    }
  }
}

/**
 * Merge of `getServiceStatusSaga` and `getCaseStatusSaga`
 *
 * Useful for sharing JWT token
 */
export function* getCaseAndServiceStatusSaga() {
  try {
    const caseReference = yield select(caseReferenceSelector);
    const moveVersion = yield select(selectMoveVersion);
    const partner = yield select(partnerSelector);
    const sessionToken = yield getSynergySessionToken();
    const tenantId = yield select(selectTenantId);

    const caseStatusRes = yield call(getSynergyCaseStatus, {
      caseId: caseReference,
      token: sessionToken,
      moveVersion,
      tenantId,
    });

    yield put(
      actions.getServiceStatusStart({
        caseReference,
      }),
    );

    if (caseStatusRes.status === 200 && caseStatusRes.result?.length > 0) {
      yield put(actions.getCaseStatusSuccess(caseStatusRes.result));
    } else {
      yield put(actions.getCaseStatusError('Case not found'));
    }

    const serviceStatusRes = yield call(getServiceStatusApi, {
      caseId: caseReference,
      token: sessionToken,
      moveVersion,
      partner,
      tenantId,
    });

    if (serviceStatusRes.ok && serviceStatusRes.result?.length > 0) {
      yield put(actions.getServiceStatusSuccess(serviceStatusRes.result));
    } else {
      yield put(actions.getServiceStatusFail('No services'));
    }
  } catch (error) {
    console.error({ error });
    yield put(actions.getCaseStatusError('Unexpected error'));
    yield put(actions.getServiceStatusFail('Unexpected error'));
  }
}
